import { render, staticRenderFns } from "./modalConfigurarEquipo.vue?vue&type=template&id=32c7d60c&"
import script from "./modalConfigurarEquipo.vue?vue&type=script&lang=js&"
export * from "./modalConfigurarEquipo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports